import { FC } from 'react';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Select from 'src/components/Form/Select';
import TextField from 'src/components/Form/TextField';
import { statesOptions } from 'src/utils/constants';

const statusItems = [
  { key: 1, label: 'Ativo', value: 'active' },
  { key: 2, label: 'Inativo', value: 'inactive' },
];

const Filters: FC = () => {
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField name="zip_code" label="CEP" size="small" />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Select name="state" label="UF" items={statesOptions} size="small" />
      </Grid>

      <Grid item xs={12}>
        <TextField name="city" label="Cidade" size="small" />
      </Grid>

      <Grid item xs={12}>
        <TextField name="neighborhood" label="Bairro" size="small" />
      </Grid>

      <Grid item xs={12} sm={9}>
        <TextField name="street" label="Rua/Av" size="small" />
      </Grid>

      <Grid item xs={12} sm={3}>
        <TextField name="number" label="Número" size="small" />
      </Grid>

      <Grid item xs={12}>
        <TextField name="complement" label="Complemento" size="small" />
      </Grid>

      <Grid item xs={6}>
        <Select name="status" label="Status" items={statusItems} size="small" />
      </Grid>
    </>
  );
};

export default Filters;
